const ListWrapper = (props) => {
    return (
        <div>
            {props.children}
        </div>
    );
};

export default ListWrapper;